import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import AboutSection from "../components/About";
import WhyChoose from "../components/WhyChoose";
import serviceBg from "../assets/hero3.png";
import "./About.css";

const About = () => {
  return (
    <>
     <Helmet>
  <title>
   About Customersupports24x7 Appliance Repair Bangalore
  </title>

  <meta
    name="description"
    content="Learn about Customersupports24x7, a trusted provider of appliance repair services in Bangalore. We offer professional appliance repair Bangalore solutions for washing machines, refrigerators, ACs, microwaves, TVs, and other home appliances across all major brands."
  />

  <meta
    name="keywords"
    content="about appliance repair bangalore, appliance repair services in Bangalore"
  />

  <link
    rel="canonical"
    href="https://customersupports24x7.in/about"
  />
</Helmet>

      <InnerBanner title="About Us" bgImage={serviceBg} />
      <AboutSection />
      <WhyChoose />
    </>
  );
};

export default About;
